<template>
  <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
    <v-row>
      <v-col cols="12">
        <header-medium :text="$t('Authenticate.Title')" />
      </v-col>
    </v-row>

    <v-row justify="space-around">
      <v-col cols="12">
        <v-alert :color="mainColor" text type="info">
          {{ $t("info_certificate_password_2factor") }}
        </v-alert>
      </v-col>
    </v-row>

    <v-form ref="check2FactorQes">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="6" md="4" offset-md="4">
          <v-text-field v-model="password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'" :label="$t('certificate_password')" dense
            @click:append="showPassword = !showPassword" :rules="rules.password"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-card-text>
          <v-container class="ma-0 pa-0 mw-100">
            <p v-text="$t('Authenticate.KeySendMessage_1')" class="text-center mb-0"></p>
            <p v-text="$t('Authenticate.KeySendMessage_2')" class="text-center mb-0"></p>
            <p v-text="$t('Authenticate.KeySendMessage_3')" class="text-center"></p>
          </v-container>
          <v-row class="justify-center">
            <v-col cols="12" sm="5" md="5">
              <v-otp-input v-model="otp" @finish="focusSubmit" :label="$t('Authenticate.EnterCode')" type="number"></v-otp-input>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="12" sm="5" md="5">
              <p class="text-center ma-0 pa-0 caption">
                {{ $t("Authenticate.reference") }}{{ reference }}
              </p>
            </v-col>
          </v-row>
          <v-row class="justify-center d-flex">
            <v-col cols="12" sm="5" md="5">
              <p class="text-center ma-0 pa-0 caption">
                <v-btn color="primary" @click="retryPhone" plain :disabled="disableRetry">
                  <p class="text-wrap" style="width: auto; margin: auto;">{{ $t("Authenticate.NotReceivedPhoneCall") }}
                  </p>
                </v-btn>
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-row>
    </v-form>
    <v-row class="pt-5" dense v-if="!mobile">
      <v-col cols="12" sm="4" class="text-left">
        <custom-button :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
      </v-col>
      <v-col cols="12" sm="8" class="text-right">
        <custom-button :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
        <custom-button id="sign" :disabled="disabled" :text="buttonText" @click="sign"></custom-button>
      </v-col>
    </v-row>
    <v-row v-if="mobile">
      <v-col cols="12" sm="8" class="text-center">
        <custom-button :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"
          styleString="padding-left: 24px; padding-right: 24px"></custom-button>
      </v-col>
    </v-row>
    <v-row v-if="mobile">
      <v-col cols="12" sm="8" class="text-center">
        <custom-button :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
        <custom-button id="sign" :disabled="disabled" :text="buttonText" @click="sign"></custom-button>
      </v-col>
    </v-row>
    <custom-overlay></custom-overlay>
  </v-card>
</template>
<script>
import i18n from "@/i18n";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import CustomButton from "../../components/ui/input/CustomButton.vue";
import { log } from "@/helpers/logger";
import CustomOverlay from "../../components/ui/other/Overlay.vue";

export default {
  name: "qes-authenticate-phone",
  title: i18n.t("Authenticate.Title"),
  components: {
    HeaderMedium,
    CustomButton,
    CustomOverlay,
  },
  data() {
    return {
      buttonText: '',
      mainColor: this.$vuetify.theme.themes.light.primary,
      workflow: null,
      showPassword: false,
      rules: {
        password: [(v) => !!v || this.$t("required")],
      },
      password: "",
      otp: "",
      time: 0,
      disableRetry: false,
      phoneCalled: false,
    };
  },
  created: async function () {
    this.$emit("step", 3);
    this.workflow = this.currentWorkflow;

    this.buttonText = this.workflow.signer_type.split("_")[1] === 'signature' ? i18n.t('Navigation.sign_now') : i18n.t('Navigation.seal_now')

    await this.$store
      .dispatch("data/getPhoneQualified", this.workflow)
      .then(() => {
        this.phoneCalled = true;
      })
      .catch((err) => {
        log("QesAuthenticate.createdPhone() - " + err, 'error');
        return;
      });
    this.color = this.$vuetify.theme.themes.light.primary;
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    disabled() {
      return this.$store.state.loading;
    },
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
    currentFiles() {
      return this.$store.state.data.files;
    },
    reference() {
      return this.$store.state.data.reference;
    },
  },
  methods: {
    focusSubmit() {
     document.getElementById("sign").focus();
    }, 
    cancel() {
      this.$emit("refuse", true);
    },
    retryPhone() {
      this.time = 0;

      this.disableRetry = true;

      this.$store.dispatch("data/getPhoneQualified", this.workflow).finally(() => {
        this.time = 300;
        setTimeout(function () {
          this.disableRetry = false;
        }, 10800);
      });
    },
    nextPage(val) {
      this.$store.state.auth.workflow = this.workflow;
      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/authenticate2fa"
      );
      this.$store.commit("set_loading", true);
    },
    async sign() {
      if (this.$refs.check2FactorQes.validate()) {
        this.$store
          .dispatch("data/checkSMS", {
            workflow: this.currentWorkflow,
            auth_token: this.$store.state.data.auth_token,
            otp: this.otp,
          })
          .then(() => {
            this.$store
              .dispatch("data/checkCertificatePassword", {
                workflow: this.currentWorkflow,
                password: this.password
              })
              .then(() => {
                this.$store
                  .dispatch("data/signNowQes2Fa", {
                    workflow: this.currentWorkflow,
                    files: this.currentFiles,
                    auth_token: this.$store.state.data.auth_token,
                    otp: this.otp,
                    ip: this.currentWorkflow.ip,
                    password: this.password
                  })
                  .then(() => {
                    log(
                      "MainPage.Authenticate.sign() - sign now workflow " +
                      this.currentWorkflow.workflow_id +
                      " by signer " +
                      this.currentWorkflow.signer_id,
                      "info"
                    );
                    this.$router.push("/summary/finished");
                  })
                  .catch((err) => {
                    this.otp = "";
                    log("MainPage.Authenticate2fa.sign() - " + err, "error");
                  })
              })
              .catch((err) => {
                this.otp = "";
                log("MainPage.Authenticate2fa.sign() - " + err, "error");
              })
          })
      }
    },
  }
};
</script>
<style>
.v-btn__content {
  width: 100%;
  white-space: normal;
}
</style>